
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"24.3","cy":"15.68","r":"14.08","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"d":"M38.51 15.21a15.23 15.23 0 00-14.7 14.66M10.1 16.15a15.14 15.14 0 0010.25-4.44A15.15 15.15 0 0024.8 1.5M34.44 5.55L14.17 25.82M34.44 25.82L14.17 5.55M8.79 23.54l-6.53 6.52M11.63 28.36L1.49 38.5M16.45 31.2L9.6 38.05","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    